import { getUserFollowingList, getUserProposalVotes } from "services/user-service";
import { Buffer } from "buffer";
// window.Buffer = window.Buffer || require("buffer").Buffer;  
const storage = {
  USER: "user",
  SIGNED_IN: "signedIn",
  AUTOLOGIN: "autologin",
  FOLLOWING:"following",
  PROPOSALS: "proposals"
}; 
export function saveLoginInfo(user: any, saveProposals = true, enableAutologin = true, saveFollowing = true) {
  if (user !== "") { 
    localStorage.removeItem(storage.USER);
    localStorage.removeItem(storage.SIGNED_IN);
    localStorage.removeItem(storage.AUTOLOGIN);
    localStorage.removeItem(storage.PROPOSALS);
    localStorage.removeItem(storage.FOLLOWING);

    localStorage.setItem(storage.USER, user); 
    localStorage.setItem(storage.SIGNED_IN, JSON.stringify(true));

    if (enableAutologin) {
      const buff = packSessionData(user);
      localStorage.setItem(storage.AUTOLOGIN, JSON.stringify(buff));
    }

    if (saveProposals) {
      getUserProposalVotes(user).then(result => {
        localStorage.setItem(storage.PROPOSALS, JSON.stringify(result.voterProposals));
      });
    }

    if (saveFollowing) {
      getUserFollowingList(user).then(result => {
        localStorage.setItem(storage.FOLLOWING, JSON.stringify(result));
      });
    }
  }
}
export function packSessionData(user) {
  let buff = new Buffer(
    `${user.user}\t${user.password}`
    ).toString('hex');
  return buff;
}
export function extractSessionData(data) {
  return new Buffer(data, 'hex').toString().split('\t');
}